import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import style from './style.lit.css';
import '../date_widget/element.js';
import '../origin/element.js';

/**
 * Card item that displays date, title and origin in a row
 *
 * @prop date - Date for date widget
 * @prop url - Where to redirect user on click?
 * @prop originName - Origin name for xs-origin
 * @prop originPicture - Origin picture for xs-origin (optional)
 * @prop originIcon - Origin Icon for xs-origin (optional)
 *
 * @cssprop [--bg: var(--contrast-light)] Element background
 * @cssprop [--bg-hover: var(--gray-100)] Element background when hovered
 * @cssprop [--bg-active: var(--gray-200)] Element background when active
 *
 * @slot default - Card title
 */

export default class CardItem2 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    date: { type: Date },
    url: { type: String },
    originName: { type: String },
    originPicture: { type: String },
    originIcon: { type: String },
  };

  render() {
    return html`
      <a href=${this.url}>
        <xs-card-date-widget .date=${this.date} layout="inline">
        </xs-card-date-widget>
        <main>
          <slot></slot>
          <xs-origin
            picture=${ifDefined(this.originPicture)}
            icon=${ifDefined(this.originIcon)}>
            <span class="small-label">${this.originName}</span>
          </xs-origin>
        </main>
      </a>
    `;
  }
}

customElements.get('xs-card-item-2') ||
  customElements.define('xs-card-item-2', CardItem2);
